import { createSelector } from 'reselect';

import {
  // Navigation
  navigationCampusSelector,
  navigationContentSelector,
  navigationEventsSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  brandManagerEditorSelector,
  navigationServicesSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
  navigationSettingsPersonalSelector,
  navigationLogoutPersonalSelector,
  navigationHelpFooterSelector,
  navigationImprintSelector,
  navigationTAndCSelector,
  navigationPrivacyAtXingSelector,
  navigationPrivacyPolicySelector,
  // Features
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  featuresIsCampusNormalPositionSelector,
  featuresIsCampusProminentPositionSelector,
  featuresIsBrandManageEditorSelector,
  // Props
  localeSelector,
} from '../../../selectors';
import { localizedLink } from '../../../selectors/utils';

const secondaryInputSelectors = [
  localeSelector,
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  featuresIsCampusNormalPositionSelector,
  featuresIsCampusProminentPositionSelector,
  featuresIsBrandManageEditorSelector,
  navigationCampusSelector,
  navigationContentSelector,
  navigationEventsSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  brandManagerEditorSelector,
  navigationServicesSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
  navigationSettingsPersonalSelector,
  navigationLogoutPersonalSelector,
  navigationHelpFooterSelector,
  navigationImprintSelector,
  navigationTAndCSelector,
  navigationPrivacyAtXingSelector,
  navigationPrivacyPolicySelector,
];
const secondaryTransform = (
  locale,
  isPremium,
  isProJobs,
  isProBusiness,
  isCampusNormalPosition,
  isCampusProminentPosition,
  isBrandManager,
  campus,
  content,
  events,
  groups,
  companies,
  brandManager,
  services,
  premium,
  premiumUpsell,
  proJobs,
  proBusiness,
  settingsPersonal,
  logoutPersonal,
  helpFooter,
  imprint,
  tAndC,
  privacyAtXing,
  privacyPolicy
) => {
  const getLocalizedLink = localizedLink(locale);

  const campusProminent = isCampusProminentPosition && campus;
  const campusNormal =
    !isCampusProminentPosition && isCampusNormalPosition && campus;

  return [
    [
      campusProminent,
      content,
      events,
      groups,
      companies,
      isBrandManager && brandManager,
      campusNormal,
      services,
    ]
      .filter(Boolean)
      .map(getLocalizedLink),
    [
      isPremium ? premium : premiumUpsell,
      isProJobs && proJobs,
      isProBusiness && proBusiness,
    ]
      .filter(Boolean)
      .map(getLocalizedLink),
    [settingsPersonal].map(getLocalizedLink),
    [logoutPersonal].map(getLocalizedLink),
    [helpFooter, imprint, tAndC, privacyAtXing, privacyPolicy].map(
      getLocalizedLink
    ),
  ];
};
export default createSelector(
  ...secondaryInputSelectors,
  secondaryTransform
);
